"use strict";
// Copyright (c) 2021-2024, Brandon Lehmann <brandonlehmann@gmail.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
Object.defineProperty(exports, "__esModule", { value: true });
require("./datatables/all");
const cdn_1 = require("../helpers/cdn");
($ => {
    const setup = () => {
        $.fn.dt = function (options = {}, buttonContainer) {
            var _a;
            const $this = $(this);
            const id = $this.id();
            if (!options.destroy) {
                (_a = options.retrieve) !== null && _a !== void 0 ? _a : (options.retrieve = true);
            }
            const table = $this.DataTable(options);
            if (options.buttons) {
                if (buttonContainer) {
                    table.buttons().container().appendTo(buttonContainer);
                }
                else {
                    $(`#${id}_wrapper`)
                        .children(':first')
                        .children(':first')
                        .append(table.buttons().container());
                }
            }
            return table;
        };
    };
    if (typeof $.fn.DataTable === 'undefined' ||
        typeof window.pdfMake === 'undefined' ||
        typeof window.JSZip === 'undefined') {
        const pkgs = [
            `jszip-${(0, cdn_1.version)('jszip')}`,
            `dt-${(0, cdn_1.version)('datatables.net-bs5')}`,
            `af-${(0, cdn_1.version)('datatables.net-autofill-bs5')}`,
            `b-${(0, cdn_1.version)('datatables.net-buttons-bs5')}`,
            `b-colvis-${(0, cdn_1.version)('datatables.net-buttons-bs5')}`,
            `b-html5-${(0, cdn_1.version)('datatables.net-buttons-bs5')}`,
            `b-print-${(0, cdn_1.version)('datatables.net-buttons-bs5')}`,
            `cr-${(0, cdn_1.version)('datatables.net-colreorder-bs5')}`,
            `date-${(0, cdn_1.version)('datatables.net-datetime')}`,
            `fc-${(0, cdn_1.version)('datatables.net-fixedcolumns-bs5')}`,
            `fh-${(0, cdn_1.version)('datatables.net-fixedheader-bs5')}`,
            `kt-${(0, cdn_1.version)('datatables.net-keytable-bs5')}`,
            `r-${(0, cdn_1.version)('datatables.net-responsive-bs5')}`,
            `rg-${(0, cdn_1.version)('datatables.net-rowgroup-bs5')}`,
            `rr-${(0, cdn_1.version)('datatables.net-rowreorder-bs5')}`,
            `sc-${(0, cdn_1.version)('datatables.net-scroller-bs5')}`,
            `sb-${(0, cdn_1.version)('datatables.net-searchbuilder-bs5')}`,
            `sp-${(0, cdn_1.version)('datatables.net-searchpanes-bs5')}`,
            `sl-${(0, cdn_1.version)('datatables.net-select-bs5')}`,
            `sr-${(0, cdn_1.version)('datatables.net-staterestore-bs5')}`
        ].join('/');
        const pdf = (0, cdn_1.version)('pdfmake');
        $('<link rel="stylesheet" crossorigin="anonymous" referrerpolicy="no-referrer">')
            .appendTo($(document.head))
            .attr('href', `https://cdn.datatables.net/v/bs5/${pkgs}/datatables.min.css`);
        $.getScript({
            url: `${cdn_1.CDNJS}/pdfmake/${pdf}/pdfmake.min.js`,
            cache: true,
            success: () => {
                $.getScript({
                    url: `${cdn_1.CDNJS}/pdfmake/${pdf}/vfs_fonts.min.js`,
                    cache: true,
                    success: () => {
                        $.getScript({
                            url: `https://cdn.datatables.net/v/bs5/${pkgs}/datatables.min.js`,
                            cache: true,
                            success: () => setup()
                        });
                    }
                });
            }
        });
    }
    else {
        setup();
    }
})(window.$);
//# sourceMappingURL=datatables.js.map